import { render } from "./CompanyPage.vue?vue&type=template&id=72b895f8&scoped=true"
import script from "./CompanyPage.vue?vue&type=script&lang=js"
export * from "./CompanyPage.vue?vue&type=script&lang=js"

import "./CompanyPage.vue?vue&type=style&index=0&id=72b895f8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b895f8"]])

export default __exports__